import React from 'react';

const DynamicBuyerInfoModal = React.lazy(
  () => import(/* webpackChunkName: "FavouritesUiDynamicBuyerInfoModal" */ './DynamicBuyerInfoModal'),
);

const BuyerInfoModal = ({ tenant, onClose }: { tenant: string; onClose: () => void }) => {
  return (
    <React.Suspense fallback={null}>
      <DynamicBuyerInfoModal tenant={tenant} onClose={onClose} />
    </React.Suspense>
  );
};

export default BuyerInfoModal;
